import { normalizarMateriaId } from './materiasCompat';
export const REVISAO_RAPIDA=[];
export const installQuickPhrases=items=>REVISAO_RAPIDA.splice(0,REVISAO_RAPIDA.length,...items);
export const materiasComRevisaoRapida = () =>
  [...new Set(REVISAO_RAPIDA.map((item) => normalizarMateriaId(item.materia)))];

export const frasesPorMateria = (materiaId) =>
  REVISAO_RAPIDA.filter((item) => normalizarMateriaId(item.materia) === normalizarMateriaId(materiaId));
